export default "__VITE_ASSET__CQVUJDmP__"